export class ReportActivity {
    userName: string;
    createdDate: Date;
    roleName: string;
    clientName: string;
    measureName: string;
    patientName: string;
    activityName: string;
    measureId: number;
    patientId: number;
    providerId: number;
    practiceId: number;
    source: string;
    totalItems: number;
}


//measureId, measureName, templateId, templateTag, performance